export default {
  methods: {
    // NOTE เป็น Function สำหรับ Create/Update/Delete Annotation
    async updateAnnotation (hospitalId = '', seriesId = '', data = {}) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/annotation/series/${seriesId}`,
        method: 'put',
        data: { annotation: data }
      }
      return await this.awaitAxios(options)
    },
    async getAnnotation (hospitalId = '', seriesId = '') {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/annotation/series/${seriesId}`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    }
  }
}
